import httpClient from '../httpClient';

export async function getAllDestaques() {
  try {
    const response = await httpClient.get(`/api/destaque`);
    return Array.isArray(response.data.registros)
      ? response.data.registros
      : [];
  } catch (error) {
    throw new Error('Erro ao obter lista de Registros: ' + error);
  }
}

export async function getAllDestaquesPorEntidade(tab: string, id: number) {
  try {
    const response = await httpClient.get(`/api/destaque/porentidade`, {
      params: {
        tab,
        id,
      },
    });
    return Array.isArray(response.data.registros)
      ? response.data.registros
      : [];
  } catch (error) {
    throw new Error('Erro ao obter lista de Registros: ' + error);
  }
}
